import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import SuperAdminDashboard from '../pages/super_admin/SuperAdminDashboard';
import SuperAdminRevenueAnalytics from '../pages/super_admin/UserManagment';
import SuperAdminListContents from '../pages/super_admin/ListContents';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminViewersAnalytics from '../pages/admin/ViewersAnalytics';
import AdminContentsApprovals from '../pages/admin/ContentsApprovals';
import AdminListContents from '../pages/admin/ListContents';
import ContentCreatorDashboard from '../pages/content_creator/ContentCreatorDashboard';
import ContentCreatorAddContent from '../pages/content_creator/AddContent';
import ContentCreatorListContents from '../pages/content_creator/ListContents';
import ContentReviewerDashboard from '../pages/content_reviewer/ContentReviewerDashboard';
import ContentReviewerListContents from '../pages/content_reviewer/ListContents';
import ContentReviewerListApprovedContents from '../pages/content_reviewer/ListApprovedContents';
import ContentReviewerListDeclinedContents from '../pages/content_reviewer/ListDeclinedContents';
import ContentReviewerListReportedContents from '../pages/content_reviewer/ListReportedContents';
import Layout from '../components/Layout';
import SuperAdminQuestions from '../pages/super_admin/SuperAdminQuestions';
import QuestionManagment from '../pages/super_admin/QuestionManagment/QuestionManagment';
import UserManagment from '../pages/super_admin/UserManagment';
import DataPipeline from '../pages/super_admin/DataPipeline';
import GameManagement from '../pages/super_admin/GameManagement';
import CreateModifyGame from '../pages/super_admin/CreateModifyGame';
import EntertainmentEntityManagement from '../pages/super_admin/EntertainmentEntityManagement';
import CreateEntertainmentEntity from '../pages/super_admin/CreateEntertainmentEntity';
import CreateMultimediaEntity from '../pages/super_admin/CreateMultimediaEntity';
import FantasyLeagueGameActiveStats from '../pages/super_admin/FantasyLeagueGameActiveStats';
import RapHousieManagment from '../pages/super_admin/RapHousie/RapHousieManagment';
import RapHousieGame from '../pages/super_admin/RapHousie/RapHousieGame';
import RapHousieMultimedia from '../pages/super_admin/RapHousie/RapHousieMultimedia';
import RapHousiCreateMultimedia from '../pages/super_admin/RapHousie/RapHousiCreateMultimedia';
import RapHousiCreateGame from '../pages/super_admin/RapHousie/RapHousiCreateGame';
import UploadCSV from '../pages/super_admin/UploadCSV/UploadCSV';
import UploadImage from '../pages/super_admin/UploadImage/UploadImage';
import ClientUserManagment from '../pages/super_admin/ClientUserManagment/ClientUserManagment';
import UserTransaction from '../pages/super_admin/UserTransaction';
import SalesDashboard from '../pages/super_admin/SalesDashboard';
import CreateQuestion from '../pages/super_admin/QuestionManagment/CreateQuestion';
import Rapshorts from '../pages/super_admin/Rapshorts';
import RapStudio from '../pages/super_admin/RapStudio';
import FeedbackFormsList from '../pages/super_admin/FeedbackForms/FeedbackFormsList';
import FeedbackFormBuilder from '../pages/super_admin/FeedbackForms/FeedbackFormBuilder';
import FeedbackFormResponses from '../pages/super_admin/FeedbackForms/FeedbackFormResponses';
import FeedbackResponseDetail from '../pages/super_admin/FeedbackForms/FeedbackResponseDetail';

export default function RoleBasedRoutes({ role, userData, signout }) {

  console.log("RoleBasedRoutes role : ", role)
  console.log("RoleBasedRoutes userData : ", userData)

  if (!role) {
    return <div>Please contact admin to assign a role.</div>;
  }

  return (
    <Routes>
      <Route element={<Layout userData={userData} signout={signout} />}>
        {role === 'Super Admin' && (
          <>
            <Route path="/" element={<PrivateRoute><SuperAdminDashboard /></PrivateRoute>} />
            <Route path="/user-managment" element={<PrivateRoute><UserManagment userData={userData} /></PrivateRoute>} />
            {/* <Route path="/questions" element={<PrivateRoute><SuperAdminQuestions /></PrivateRoute>} /> */}
            <Route path="/questions" element={<PrivateRoute><QuestionManagment /></PrivateRoute>} >
              <Route
                key={"create-question"}
                path={"create-question"}
                element={
                  <PrivateRoute>
                    <CreateQuestion />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="/list-contents" element={<PrivateRoute><SuperAdminListContents /></PrivateRoute>} />
            <Route path="/data-pipeline" element={<PrivateRoute><DataPipeline /></PrivateRoute>} />
            <Route path="/entertainment-entity-management" element={<PrivateRoute><EntertainmentEntityManagement /></PrivateRoute>}>
              <Route
                key={"create-entertainment-entity"}
                path={"create-entertainment-entity"}
                element={
                  <PrivateRoute>
                    <CreateEntertainmentEntity />
                  </PrivateRoute>
                }
              >
                <Route
                  key={"create-multimedia-entity"}
                  path={"create-multimedia-entity"}
                  element={
                    <PrivateRoute>
                      <CreateMultimediaEntity />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Route>
            <Route path="/game-management" element={<PrivateRoute><GameManagement /></PrivateRoute>} >
              <Route
                key={"create-game"}
                path={"create-modify-game"}
                element={
                  <PrivateRoute>
                    <CreateModifyGame />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="/fl-active-stats" element={<PrivateRoute><FantasyLeagueGameActiveStats /></PrivateRoute>} ></Route>
            <Route path="/rap-housie-managment" element={<PrivateRoute><RapHousieManagment /></PrivateRoute>}>
              <Route
                key={"rapgame"}
                path="rapgame"
                element={<PrivateRoute><RapHousieGame /></PrivateRoute>}
              >
                <Route
                  key={"create-raphousie-game"}
                  path={"create-raphousie-game"}
                  element={
                    <PrivateRoute>
                      <RapHousiCreateGame />
                    </PrivateRoute>
                  }
                />
              </Route>
              <Route
                key={"rapmultimedia"}
                path="rapmultimedia"
                element={<PrivateRoute><RapHousieMultimedia /></PrivateRoute>}>
                <Route
                  key={"create-raphousie-multimedia"}
                  path={"create-raphousie-multimedia"}
                  element={
                    <PrivateRoute>
                      <RapHousiCreateMultimedia />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Route>
            <Route path="/upload-csv" element={<PrivateRoute><UploadCSV /></PrivateRoute>} />
            <Route path="/upload-multimedia" element={<PrivateRoute><UploadImage /></PrivateRoute>} />
            <Route path="/client-user-managment" element={<PrivateRoute><ClientUserManagment userData={userData} /></PrivateRoute>} />
            <Route path="/user-transaction" element={<PrivateRoute><UserTransaction /></PrivateRoute>} />
            <Route path="/sales-dashboard" element={<PrivateRoute><SalesDashboard /></PrivateRoute>} />
            <Route path="/rapshorts" element={<PrivateRoute><Rapshorts /></PrivateRoute>} />
            <Route path="/rap-studio" element={<PrivateRoute><RapStudio /></PrivateRoute>} />
            <Route path="/feedback-forms" element={<PrivateRoute><FeedbackFormsList /></PrivateRoute>} />
            <Route path="/feedback-forms/:id/responses/:responseId" element={<PrivateRoute><FeedbackResponseDetail /></PrivateRoute>} />
            <Route path="/feedback-forms/:id/responses" element={<PrivateRoute><FeedbackFormResponses /></PrivateRoute>} />
            <Route path="/feedback-forms/:id" element={<PrivateRoute><FeedbackFormBuilder /></PrivateRoute>} />
          </>
        )}
        {role === 'Admin' && (
          <>
            <Route path="/" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
            <Route path="/viewers-analytics" element={<PrivateRoute><AdminViewersAnalytics /></PrivateRoute>} />
            <Route path="/contents-approvals" element={<PrivateRoute><AdminContentsApprovals /></PrivateRoute>} />
            <Route path="/list-contents" element={<PrivateRoute><AdminListContents /></PrivateRoute>} />
            <Route path="/feedback-forms" element={<PrivateRoute><FeedbackFormsList /></PrivateRoute>} />
            <Route path="/feedback-forms/:id/responses/:responseId" element={<PrivateRoute><FeedbackResponseDetail /></PrivateRoute>} />
            <Route path="/feedback-forms/:id/responses" element={<PrivateRoute><FeedbackFormResponses /></PrivateRoute>} />
            <Route path="/feedback-forms/:id" element={<PrivateRoute><FeedbackFormBuilder /></PrivateRoute>} />
          </>
        )}
        {role === 'Content Creator' && (
          <>
            <Route path="/" element={<PrivateRoute><ContentCreatorDashboard /></PrivateRoute>} />
            <Route path="/add-content" element={<PrivateRoute><ContentCreatorAddContent /></PrivateRoute>} />
            <Route path="/list-contents" element={<PrivateRoute><ContentCreatorListContents /></PrivateRoute>} />
          </>
        )}
        {role === 'Content Reviewer' && (
          <>
            <Route path="/" element={<PrivateRoute><ContentReviewerDashboard /></PrivateRoute>} />
            <Route path="/list-contents" element={<PrivateRoute><ContentReviewerListContents /></PrivateRoute>} />
            <Route path="/list-approved-contents" element={<PrivateRoute><ContentReviewerListApprovedContents /></PrivateRoute>} />
            <Route path="/list-declined-contents" element={<PrivateRoute><ContentReviewerListDeclinedContents /></PrivateRoute>} />
            <Route path="/list-reported-contents" element={<PrivateRoute><ContentReviewerListReportedContents /></PrivateRoute>} />
          </>
        )}
      </Route>
      {/* Catch all unknown routes */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
